import React from 'react'
import PropTypes from 'prop-types'
import {Box, Flex, Text, Image, Button, useStyleConfig} from '@chakra-ui/react'
import {TextTitleDescription} from '../../text-title-description'
import {ChevronRight} from '../../../icons'
import CustomLink from '../../../custom-link'
import {useGetCategoriesData} from '../../../../custom-api/hooks/use-get-categories-data'
import {getGlobalLink} from '../../../../utils/contentstack-utils'
import useDamImage from '../../../../custom-hooks/use-dam-image'
import {useProducts} from '@salesforce/commerce-sdk-react'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

const PromoSlideCard = ({title, bodyCopy, button, url, alt, image, tabIndex}) => {
    const styles = useStyleConfig('PromoSlider')
    const categoriesData = useGetCategoriesData()
    const {locale} = useMultiSite()
    const {data: productsData} = useProducts(
        {
            parameters: {
                ids: button?.productsfcc?.data?.length > 0 ? button.productsfcc.data[0].id : '',
                expand: ['availability', 'images'],
            },
            headers: {
                'x-debug': 'promo-slider-index',
            },
        },
        {
            enabled: button?.productsfcc?.data?.length > 0,
        },
    )
    const {
        url: ctaUrl,
        label: ctaLabel,
        isAbsolute,
    } = getGlobalLink({
        link: button,
        categoriesData,
        productsData,
        locale: locale?.alias || locale?.id?.toLowerCase(),
    })
    const {url: imageUrl} = useDamImage(image)

    // const handleRedirect = (e) => {
    //     e.preventDefault()
    //     if (cta && cta?.href) {
    //         isExternalUrl ? window.open(cta.href, '_blank') : navigate(cta.href)
    //     }
    // }

    const imageToDisplay = imageUrl || url

    return (
        <CustomLink
            sx={styles.sliderLinkContainer}
            isExternal={isAbsolute}
            href={ctaUrl}
            data-testid="promo-slide-card-link"
            tabIndex={tabIndex}
        >
            <Flex sx={styles.sliderContainer} data-testid={`swiper-slide-${title || 'container'}`}>
                <Box sx={styles.imageContainer} data-testid="promo-slider-image-container">
                    <Image
                        src={imageToDisplay}
                        alt={alt}
                        loading="lazy"
                        {...styles.promoSliderImage}
                        data-testid="promo-slider-image"
                    />
                </Box>
                <Flex sx={styles.contentContainer}>
                    <TextTitleDescription title={title} {...styles.textTitleDescription}>
                        {bodyCopy}
                    </TextTitleDescription>
                    {ctaLabel && (
                        <Button
                            {...styles.promoSliderCardButton}
                            rightIcon={
                                <ChevronRight aria-hidden="true" {...styles.imageCardChevronIcon} />
                            }
                            aria-label={ctaLabel}
                            tabIndex={-1}
                        >
                            <Text as="span" {...styles.promoSlideCardText}>
                                {ctaLabel}
                            </Text>
                        </Button>
                    )}
                </Flex>
            </Flex>
        </CustomLink>
    )
}

PromoSlideCard.propTypes = {
    title: PropTypes.string,
    bodyCopy: PropTypes.string,
    button: PropTypes.object,
    url: PropTypes.string,
    alt: PropTypes.string,
    image: PropTypes.object,
    tabIndex: PropTypes.number,
}

export default PromoSlideCard
